export default __webpack_public_path__ + "static/media/dtsu5168_direct_gw214.b31bcfe2.png";